import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import StkIssSync02Actions, { StkIssSync02Types } from '../Stores/StkIssSync02/Actions';

const getAppStore = state => state.app;

export function* stkIssSync02FetchStkIssSync02({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(StkIssSync02Actions.stkIssSync02FetchStkIssSync02Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkIss/indexProcess/STK_ISS_SYNC_02/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        StkIssSync02Actions.stkIssSync02FetchStkIssSync02Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkIssSync02Actions.stkIssSync02FetchStkIssSync02Loading(false));
  }
}

export function* stkIssSync02GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/stkIssDetail/update/${hdrId}`));
}

export function* stkIssSync02SyncNow({ hdrIds }) {
  try {
    yield put(StkIssSync02Actions.stkIssSync02SyncLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `stkIss/syncProcess/STK_ISS_SYNC_02`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(StkIssSync02Actions.stkIssSync02SyncNowSuccess());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkIssSync02Actions.stkIssSync02SyncLoading(false));
  }
}

export const saga = [
  takeLatest(StkIssSync02Types.STK_ISS_SYNC02_GO_TO_DOCUMENT, stkIssSync02GoToDocument),
  takeLatest(StkIssSync02Types.STK_ISS_SYNC02_FETCH_STK_ISS_SYNC02, stkIssSync02FetchStkIssSync02),
  takeLatest(StkIssSync02Types.STK_ISS_SYNC02_SYNC_NOW, stkIssSync02SyncNow)
];
